import React from "react";
import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";

import SoftwareNotifications from "./SoftwareNotifications.jsx";

const messages = {
  notifications: {
    id: "modules.SoftwareNotification.components.Dashboard.notifications",
    description: "Messages label.",
    defaultMessage: "ICT News - messages",
  },
};

const Dashboard = () => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {formatMessage(messages.notifications)}
      </Card.Header>
      <Card.Body>
        <SoftwareNotifications />
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
